/* eslint-disable max-classes-per-file */
export class LoadAttachmentCategories {
  static readonly type = '[Attachments] Load Attachment Categories';
}

export class LoadAttachmentUnallowedFileTypes {
  static readonly type = '[Attachments] Load Attachment Unallowed File Types';
}
